(() => {
  function sanitizeCount(value) {
    const count = Number(value);

    if (!Number.isFinite(count) || count < 0) {
      return 0;
    }

    return Math.floor(count);
  }

  function getWishlistCount() {
    if (
      window.CTWishlist &&
      typeof window.CTWishlist.getHandles === 'function'
    ) {
      const handles = window.CTWishlist.getHandles();

      return Array.isArray(handles)
        ? handles.length
        : 0;
    }

    return 0;
  }

  function updateHeaderWishlist(count = getWishlistCount()) {
    const safeCount = sanitizeCount(count);

    document
      .querySelectorAll('[data-ct-wishlist-link]')
      .forEach((wishlistLink) => {
        const countElement = wishlistLink.querySelector(
          '[data-ct-wishlist-count]'
        );

        const labelElement = wishlistLink.querySelector(
          '[data-ct-wishlist-label]'
        );

        const itemLabel =
          safeCount === 1 ? 'item' : 'items';

        const accessibleLabel =
          `Wishlist, ${safeCount} ${itemLabel}`;

        if (countElement) {
          countElement.textContent =
            safeCount > 99 ? '99+' : String(safeCount);

          countElement.hidden = safeCount === 0;
        }

        if (labelElement) {
          labelElement.textContent = 'Wishlist';
        }

        wishlistLink.setAttribute(
          'aria-label',
          accessibleLabel
        );
      });
  }

  document.addEventListener(
    'ct:wishlist:updated',
    (event) => {
      const count = event.detail?.count;

      updateHeaderWishlist(
        typeof count === 'number'
          ? count
          : getWishlistCount()
      );
    }
  );

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      updateHeaderWishlist();
    }
  );

  window.addEventListener('pageshow', () => {
    updateHeaderWishlist();
  });

  window.CTWishlistHeader = {
    refresh() {
      updateHeaderWishlist();
    },
  };
})();
